import script from "./formulaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./formulaModal.vue?vue&type=script&setup=true&lang=js"

import "./formulaModal.vue?vue&type=style&index=0&id=581fb519&lang=scss"

const __exports__ = script;

export default __exports__